import { attributes, define } from "@type-r/models";
import { globalStore } from "api";
import { Page } from "lqx-react";
import * as React from "react";
import { PaymentRaLandingSummary } from "../api/payments";
import { SelectFilter, ToDo } from "../common";
import { TodoDetails as PaymentsTodoDetails, TodoTiles as PaymentsTodoTiles } from "./todo";
import { ReviewDetails as PaymentsReviewDetails, ReviewTiles as PaymentsReviewTiles } from "./review";

@define
export class PaymentsLandingState extends attributes({
    filter: 'todo',
    category: 'unresolved-payments',
    paymentRa: PaymentRaLandingSummary
}) {

    async fetch() {
        await this.paymentRa.fetch();
        
        this.paymentRa.unreconciledArPayments.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        return this;
    }

    get getCount() {
        return this.paymentRa.todoCount;
    }
    
    get isReady(){
        return this.paymentRa.isTodoReady;
    }
}

export const PaymentsLandingPage = ({ $state: $state }: { $state: PaymentsLandingState }) => {

    return (
        <Page
            menuWidth={450}
            maxWidth="xl"

            left={
                <>
                    <SelectFilter $filter={$state.$.filter} model={$state.paymentRa} />
                    {
                        $state.filter === "todo" ?
                            <PaymentsTodoTiles $category={$state.$.category} model={$state.paymentRa} />
                            : $state.filter === "review" ?
                                <PaymentsReviewTiles $category={$state.$.category} model={$state.paymentRa} />
                                : <ToDo />
                    }
                </>
            }
        >
            {
                $state.filter === 'todo' ?
                    <PaymentsTodoDetails category={$state.category} model={$state.paymentRa} />
                    : $state.filter === 'review' ?
                        <PaymentsReviewDetails category={$state.category} model={$state.paymentRa} />
                        : <ToDo />
            }

        </Page>
    )
}

